export interface EmailBuilderMergeTag {
  name: string;
  value: string;
  sample?: string;
}

export type EmailBuilderMergeTags = Record<string, EmailBuilderMergeTag>;

const patient_first_name = {
  name: "Patient First Name",
  value: "!--SUNO:patient_first_name--",
  sample: "{patient_first_name}"
};

const patient_preferred_name = {
  name: "Patient Preferred Name",
  value: "!--SUNO:patient_preferred_name--",
  sample: "{patient_preferred_name}"
};

const practice_name = {
  name: "Practice Name",
  value: "!--SUNO:practice_name--",
  sample: "{practice_name}"
};

const clinic_name = {
  name: "Clinic Name",
  value: "!--SUNO:clinic_name--",
  sample: "{clinic_name}"
};

const clinic_display_name = {
  name: "Clinic Display Name",
  value: "!--SUNO:clinic_display_name--",
  sample: "{clinic_display_name}"
};

const clinic_phone = {
  name: "Clinic Phone",
  value: "!--SUNO:clinic_phone--",
  sample: "{clinic_phone}"
};

const patient_full_name = {
  name: "Patient Full Name",
  value: "!--SUNO:patient_full_name--",
  sample: "{patient_full_name}"
};

const clinic_instructions = {
  name: "Clinic Instructions",
  value: "!--SUNO:clinic_instructions--",
  sample: "{clinic_instructions}"
};

const google_review_url = {
  name: "Clinic Google Review URL",
  value: "!--SUNO:google_review_url--",
  sample: "{google_review_url}"
};

const google_maps_url = {
  name: "Clinic Google Maps URL",
  value: "!--SUNO:google_maps_url--",
  sample: "{google_maps_url}"
};

const clinic_address = {
  name: "Clinic Address",
  value: "!--SUNO:clinic_address--",
  sample: "{clinic_address}"
};

const doctor_title = {
  name: "Doctor Title",
  value: "!--SUNO:doctor_title--",
  sample: "{doctor_title}"
};

const doctor_first_name = {
  name: "Doctor First Name",
  value: "!--SUNO:doctor_first_name--",
  sample: "{doctor_first_name}"
};

const doctor_last_name = {
  name: "Doctor Last Name",
  value: "!--SUNO:doctor_last_name--",
  sample: "{doctor_last_name}"
};

const doctor_full_name = {
  name: "Doctor Full Name",
  value: "!--SUNO:doctor_full_name--",
  sample: "{doctor_full_name}"
};

const reminder_confirmation_url = {
  name: "Reminder Confirmation URL",
  value: "!--SUNO:reminder_confirmation_url--",
  sample: "{reminder_confirmation_url}"
};

const private_feedback_request_url = {
  name: "Private Feedback URL",
  value: "!--SUNO:private_feedback_request_url--",
  sample: "{private_feedback_request_url}"
};

const appointment_time = {
  name: "Appointment Time",
  value: "!--SUNO:time--",
  sample: "{time}"
};

const appointment_date = {
  name: "Appointment Date",
  value: "!--SUNO:date--",
  sample: "{date}"
};

const appointment_prev_date = {
  name: "Appointment Previous Date",
  value: "!--SUNO:prev_date--",
  sample: "{prev_date}"
};

const appointment_prev_time = {
  name: "Appointment Previous Time",
  value: "!--SUNO:prev_time--",
  sample: "{prev_time}"
};

const patient_portal_link = {
  name: "Onboarding Forms URL",
  value: "!--SUNO:patient_portal_link--",
  sample: "{patient_portal_link}"
};

const telehealth_join_url = {
  name: "Telehealth Join URL",
  value: "!--SUNO:telehealth_join_url--",
  sample: "{telehealth_join_url}"
};

const telehealth_test_url = {
  name: "Telehealth Pre-Call Test URL",
  value: "!--SUNO:telehealth_test_url--",
  sample: "{telehealth_test_url}"
};

const collection_balance = {
  name: "Collection Balance",
  value: "!--SUNO:balance--",
  sample: "{balance}"
};

const collection_original_balance = {
  name: "Collection Original Balance",
  value: "!--SUNO:original_balance--",
  sample: "{original_balance}"
};

const collection_days_in_collection = {
  name: "Days in Collection",
  value: "!--SUNO:days_in_collection--",
  sample: "{days_in_collection}"
};

const collection_service_date = {
  name: "Date of Service",
  value: "!--SUNO:service_date--",
  sample: "{service_date}"
};

const collection_invoice_number = {
  name: "Invoice Number",
  value: "!--SUNO:invoice_number--",
  sample: "{invoice_number}"
};

const collection_payment_link = {
  name: "Payment Link",
  value: "!--SUNO:payment_link--",
  sample: "{payment_link}"
};

export const EMAIL_BUILDER_MERGE_TAGS = {
  patient_first_name,
  patient_preferred_name,
  practice_name,
  clinic_name,
  clinic_display_name,
  clinic_phone
};

export const EXTENDED_EMAIL_BUILDER_MERGE_TAGS = {
  ...EMAIL_BUILDER_MERGE_TAGS,
  patient_full_name,
  clinic_instructions,
  google_review_url,
  google_maps_url,
  clinic_address,
  doctor_title,
  doctor_first_name,
  doctor_last_name,
  doctor_full_name,
  reminder_confirmation_url,
  private_feedback_request_url,
  appointment_time,
  appointment_date,
  appointment_prev_date,
  appointment_prev_time,
  patient_portal_link,
  telehealth_join_url,
  telehealth_test_url
};

export const EMAIL_BUILDER_SPECIAL_LINKS: UnlayerSpecialLink[] = [];

export const EXTENDED_EMAIL_BUILDER_SPECIAL_LINKS: UnlayerSpecialLink[] = [
  {
    name: "Merge Tags",
    specialLinks: [
      {
        name: "Clinic Google Review URL",
        href: "!--SUNO:google_review_url--",
        target: "_blank"
      },
      {
        name: "Clinic Google Maps URL",
        href: "!--SUNO:google_maps_url--",
        target: "_blank"
      },
      {
        name: "Reminder Confirmation URL",
        href: "!--SUNO:reminder_confirmation_url--",
        target: "_blank"
      },
      {
        name: "Private Feedback URL",
        href: "!--SUNO:private_feedback_request_url--",
        target: "_blank"
      },
      {
        name: "Onboarding Forms URL",
        href: "!--SUNO:patient_portal_link--",
        target: "_blank"
      },
      {
        name: "Telehealth Join URL",
        href: "!--SUNO:telehealth_join_url--",
        target: "_blank"
      }
    ]
  }
];

export const COLLECTION_EMAIL_BUILDER_MERGE_TAGS = {
  ...EMAIL_BUILDER_MERGE_TAGS,
  collection_balance,
  collection_original_balance,
  collection_days_in_collection,
  collection_service_date,
  collection_invoice_number,
  collection_payment_link
};

export const COLLECTION_EMAIL_BUILDER_SPECIAL_LINKS: UnlayerSpecialLink[] = [
  {
    name: "Merge Tags",
    specialLinks: [
      {
        name: "Payment Link",
        href: "!--SUNO:payment_link--",
        target: "_blank"
      }
    ]
  }
];
